import React from 'react';
import classNames from 'classnames';

import {ErrorField} from 'components/Fields';

import './styles.css';

/*
  The text from the textarea contains `\n` that are not rendered as </br> in HTML
  In order to keep the new lines when we fill in the stretcher div we need to
  replace these `\n` with </br> react objects
*/
const textToHtml = text => (
  <React.Fragment>
    {text.split('\n').map((x, index) => (
      <React.Fragment key={index}>
        {x}
        <br />
      </React.Fragment>
    ))}
  </React.Fragment>
);

const ExpandingTextAreaField = ({
  input: {onBlur, onChange, value},
  placeholder,
  className,
  disabled,
  minHeight,
  maxHeight,
  onKeyDown,
  meta: {touched, error}
}: any) => {
  const minHeightStyle = minHeight ? {minHeight} : {};
  const maxHeightStyle = maxHeight ? {maxHeight} : {};
  return (
    <div className="ExpandingTextAreaField">
      <div className="textareaWrapper">
        <div
          className="strecher"
          style={{...minHeightStyle, ...maxHeightStyle}}>
          {textToHtml(value)}
        </div>
        <textarea
          onChange={onChange}
          onBlur={onBlur}
          className={classNames(
            {error: touched && error, disabled: disabled},
            className
          )}
          placeholder={placeholder}
          disabled={disabled}
          value={value}
          onKeyDown={onKeyDown}
        />
      </div>
      <ErrorField touched={touched} error={error} />
    </div>
  );
};

export default ExpandingTextAreaField;
